import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { FILEUPLOAD, GETSQLFILEDETAILS, QAMATRIXDATA, MACHINELIST, FILEUPLOADSQL, GETUPLOADERRORDETAILS, GETCURRENCYLIST, GETALLINCIDENTDATABYFILEID, GETDELETEHISTORY, DELETEINCIDENTDATAS, UPLOADSTATUS, SAVESTATUS } from '../common/constants/labels';
import { environment } from '../../environments/environment';
import { ApiService } from '../common/services/api/api.service';
import { UploadedIncidentFileDetails } from '../common/models/incident-upload';
import { UploadErrorDetails } from '../common/models/UploadErrorDetails';
import { Router } from '@angular/router';
import { CurrencyList, DeletedHistoryModel, DeleteIncidentDataModel, IncidentData } from '../common/models/incident-dashboard-filterparameterdata';
import { Role } from '../common/models/role';
import { MsalService } from '@azure/msal-angular';


@Injectable({
  providedIn: 'root'
})
// service class for incident upload page of the application
export class IncidentUploadSqlService {
  fileUploadURL = environment.APISETTINGS + FILEUPLOADSQL;
  getFileDetailsURL = environment.APISETTINGS + GETSQLFILEDETAILS;
  getErrorDetailsURL = environment.APISETTINGS + GETUPLOADERRORDETAILS;
  getCurrencyURL = environment.APISETTINGS + GETCURRENCYLIST;
  // getIncidentDataByFileId = environment.APISETTINGS + GETALLINCIDENTDATABYFILEID;
  // getDeleteHistory = environment.APISETTINGS + GETDELETEHISTORY;
  deleteIncidentData = environment.APISETTINGS + DELETEINCIDENTDATAS;
  uploadStatus = environment.APISETTINGS + UPLOADSTATUS;
  saveStatus = environment.APISETTINGS + SAVESTATUS;
  // exchangeRateUploadURL = environment.APISETTINGS + CURRENCYEXCHANGERATEFILEUPLOADSQL;
  fileID: string;
  loading = true;

  constructor(private service: ApiService, private router: Router, private adalSvc: MsalService) { }
  // service method for uploading file
  public postFile(fileToUpload: File, cluster: string, site: string, bigcategory: string, currency: string): Observable<HttpEvent<any>> {
    const userId = this.adalSvc.getAccount().name;
    const finalURl = this.fileUploadURL + cluster + '/' + site + '/' + bigcategory + '/' + currency;
    return this.service.inputXMLSql(fileToUpload, finalURl);
  }

  // service method to get file details
  public getIncidentFiles(cluster: string, site: string, role: any): Observable<Array<UploadedIncidentFileDetails>> {
    if (role === Role.qualityChampion) {
      return this.service.get(this.getFileDetailsURL + '?cluster=' + cluster);
    } else if (role === Role.globalAdmin) {
      return this.service.get(this.getFileDetailsURL);
    } else {
      return this.service.get(this.getFileDetailsURL + '?site=' + site);
    }


  }

   // service method to get currency list
   public getCurrency(): Observable<Array<CurrencyList>> {
    return this.service.get(this.getCurrencyURL);
  }
   // service method to get Upload Error details
   public getErrorDetails(fileId: string): Observable<Array<UploadErrorDetails>> {
    return this.service.get(this.getErrorDetailsURL + fileId);
  }
  // service method to get qa matrix data
  /* istanbul ignore next */
  public getQAMatrixData(id: number): Observable<any> {
    return this.service.get(environment.APISETTINGS + QAMATRIXDATA + id);
  }
  // service method to get qamatrix data by file id
  /* istanbul ignore next */
  public getQAMatrixDataFileId(id: number): Observable<any> {
    return this.service.get(environment.APISETTINGS + QAMATRIXDATA + id);
  }
  // service method to get list of machines by userid
  /* istanbul ignore next */
  public getMachineListByUserId(): Observable<any> {
    return this.service.get(environment.APISETTINGS + MACHINELIST);
  }
  // service method to navigate dashboard tab
  /* istanbul ignore next */
  public getQAMatrixDataFileIdDashboard(id: number): Observable<any> {
    return this.service.get(environment.APISETTINGS + QAMATRIXDATA + id);
  }

  public getIncidentDatabyFileId(id: number): Observable<Array<IncidentData>> {
    return this.service.get(environment.APISETTINGS + GETALLINCIDENTDATABYFILEID + id);
  }

  public getDeleteHistoryData(): Observable<Array<DeletedHistoryModel>> {
    return this.service.get(environment.APISETTINGS + GETDELETEHISTORY);
  }

  public deleteIncidentDatas(deleteParameter: DeleteIncidentDataModel): Observable<any> {
    return this.service.post(this.deleteIncidentData, deleteParameter);
 }

 public getUploadStatus(): Observable<any> {
  return this.service.get(this.uploadStatus);
}

public saveFreezeStatus(status): Observable<any> {
  return this.service.post(this.saveStatus + '?freezestatus=' + status, status );
}
}
